import { Component, HostBinding, Input } from '@angular/core';

@Component({
  selector: '[core-menu-horizontal-item]',
  templateUrl: './item.component.html'
})
export class CoreMenuHorizontalItemComponent {
  @Input()
  item: any;

  views = JSON.parse(localStorage.getItem('views')) ;
  userType: string = localStorage.getItem('user_type');
}

